

export enum RouteName {
    home = "home",
    market = "market",
    register = "register",
    farmRegister = "farm-register",
    userProfile = "user-profile",
    farmProfile = "admin-farm-profile",
    calendar = "calendar",
    map = "map",
    adminLogin = "admin-login",
    dashboard = "dashboard",
    users = "users",
    farms  = "farms",
    help = "help",
    redirect = "redirect"
}

export const OrganisationSlugMap: { [slug: string]: string } = {
  'sd-hot': 'Športno Društvo Hotedršica',
  'pgd-hot': 'Prostovoljno Gasilsko Društvo Hotedršica',
  'ktd-hot': 'Kulturno Turistično Društvo Hotedršica',
  'ks-hot': 'Krajevna Skupnost Hotedršica',
  'z-hot': 'Župnija Hotedršica',
  'ld-hot': 'Lovska Družina Hotedršica',
};


export const OrganisationSlugReverseMap: { [name: string]: string } = {
  'sportno drustvo hotedrsica': 'sd-hot',
  'prostovoljno gasilsko drustvo hotedrsica': 'pgd-hot',
  'kulturno turisticno drustvo hotedrsica': 'ktd-hot',
  'krajevna skupnost hotedrsica': 'ks-hot',
  'zupnija hotedrsica': 'z-hot',
  'lovska druzina hotedrsica': 'ld-hot',
};


export const fullHistory = `Pisalo se je leto 1908 ali natančneje 30. avgust 1908, ko je bila v Hotedršici v hiši Ivana Cunte na številki 33 ustanovljena javna ljudska knjižnica. Njeno delovanje je sicer prekinila 1. svetovna vojna,
  
  toda leta 1920 je delovanje knjižnice na pobudo domačega pesnika, pisatelja ter prevajalca Ivana
  
  Albrehta, ponovno zaživelo, tokrat v hiši številka 91. Tu je delovala čitalnica in knjižnica, ki jo je odtlej
  
  dolga leta vodil soimenjak pesnika in pisatelja Ivana Albrehta, njegov bratranec Ivan Albreht, po
  
  domače Tičev Ivan.
  
  Njegova predanost knjižničarskemu delu se ne kaže le skozi čas, ki ga je posvetil temu delu, ampak
  
  tudi skozi pripravljenost, sprejeti knjižnico na svoj dom. Tako se je knjižnica okrog leta 1930 preselila
  
  v hišo številka 10, na dom trgovca in gostilničarja – Tičevega Ivana, kjer sta vse do leta 1944 zanjo
  
  skrbela in ves čas sposojala knjige Ivan in njegova hči Vida. Ko sta bila leta 1944 internirana v
  
  taborišče v Nemčijo, je za knjige poskrbela Vidina mama – Alojzija Plesničar. Do konca 2. svetovne
  
  vojne jih je varno spravila in prav njej gre zasluga, da so se knjige ohranile, čeprav knjižnica takrat ni
  
  delovala.
  
  Po končani vojni so knjižnico preselili k Jožetu Šemrovu – po domače Bazinu, zanjo pa sta še naprej
  
  skrbela Ivan Albreht in njegova hči Vida, ki sta se srečno vrnila iz internacije. Leta 1950 je bila
  
  knjižnica ponovno preseljena – tokrat v zadružni dom. Ivan je tedaj že četrto desetletje neumorno
  
  skrbel za knjižnico, ki je z njegovo smrtjo leta 1966 za nekaj let zaprla svoja vrata. Vendar ni trajalo
  
  dolgo, ko je vodja občinske Matične knjižnice Logatec Marija Željko ob pomoči Metke Rupnik
  
  ponovno oživila delovanje hotenjske knjižnice. Metka Rupnik je dobri dve desetletji nadaljevala delo
  
  Ivana in svoje znanje ter ljubezen do knjig prenesla na hči Majo Rupnik in nečakinjo Urško Orešnik.
  
  Leta 2006 je knjižnica z veliko mero posluha in finančno podporo Občine Logatec ter prizadevanjem
  
  predsednika krajevne skupnosti Stanislava Nagodeta, dobila novi prostor s sodobno opremo.
  
  Leta 2010, ko je Hotedršico po močnem deževju in porušenju pregrade v Žejni dolini doletela velika
  
  poplava, je bila poplavljena tudi knjižnica. Uničenih je bilo 886 enot gradiva.Pisalo se je leto 1908 ali natančneje 30. avgust 1908, ko je bila v Hotedršici v hiši Ivana Cunte na

  številki 33 ustanovljena javna ljudska knjižnica. Njeno delovanje je sicer prekinila 1. svetovna vojna,
  
  toda leta 1920 je delovanje knjižnice na pobudo domačega pesnika, pisatelja ter prevajalca Ivana
  
  Albrehta, ponovno zaživelo, tokrat v hiši številka 91. Tu je delovala čitalnica in knjižnica, ki jo je odtlej
  
  dolga leta vodil soimenjak pesnika in pisatelja Ivana Albrehta, njegov bratranec Ivan Albreht, po
  
  domače Tičev Ivan.
  
  Njegova predanost knjižničarskemu delu se ne kaže le skozi čas, ki ga je posvetil temu delu, ampak
  
  tudi skozi pripravljenost, sprejeti knjižnico na svoj dom. Tako se je knjižnica okrog leta 1930 preselila
  
  v hišo številka 10, na dom trgovca in gostilničarja – Tičevega Ivana, kjer sta vse do leta 1944 zanjo
  
  skrbela in ves čas sposojala knjige Ivan in njegova hči Vida. Ko sta bila leta 1944 internirana v
  
  taborišče v Nemčijo, je za knjige poskrbela Vidina mama – Alojzija Plesničar. Do konca 2. svetovne
  
  vojne jih je varno spravila in prav njej gre zasluga, da so se knjige ohranile, čeprav knjižnica takrat ni
  
  delovala.
  
  Po končani vojni so knjižnico preselili k Jožetu Šemrovu – po domače Bazinu, zanjo pa sta še naprej
  
  skrbela Ivan Albreht in njegova hči Vida, ki sta se srečno vrnila iz internacije. Leta 1950 je bila
  
  knjižnica ponovno preseljena – tokrat v zadružni dom. Ivan je tedaj že četrto desetletje neumorno
  
  skrbel za knjižnico, ki je z njegovo smrtjo leta 1966 za nekaj let zaprla svoja vrata. Vendar ni trajalo
  
  dolgo, ko je vodja občinske Matične knjižnice Logatec Marija Željko ob pomoči Metke Rupnik
  
  ponovno oživila delovanje hotenjske knjižnice. Metka Rupnik je dobri dve desetletji nadaljevala delo
  
  Ivana in svoje znanje ter ljubezen do knjig prenesla na hči Majo Rupnik in nečakinjo Urško Orešnik.
  
  Leta 2006 je knjižnica z veliko mero posluha in finančno podporo Občine Logatec ter prizadevanjem
  
  predsednika krajevne skupnosti Stanislava Nagodeta, dobila novi prostor s sodobno opremo.
  
  Leta 2010, ko je Hotedršico po močnem deževju in porušenju pregrade v Žejni dolini doletela velika
  
  poplava, je bila poplavljena tudi knjižnica. Uničenih je bilo 886 enot gradiva.`